import React from 'react';

import dayjs from 'dayjs';
import styled from 'styled-components';

import { GroupType } from 'types/groups';

const Container = styled.span`
  display: flex;
  font-size: 12px;
  flex-direction: column;
`;

interface Props {
  item: GroupType;
}

const GroupsTableLastUpdated = ({ item }: Props) => {
  return (
    <Container>
      <span>{dayjs(item?.updated_at).format('MM/DD/YYYY hh:mm A')}</span>
    </Container>
  );
};

export default GroupsTableLastUpdated;
